// src/pages/b2b/B2BSchedulesPage.js - 일정 관리 페이지 (더미)

import React from 'react';
import B2BLayout from '../../components/b2b/B2BLayout';
import { usePageHeader } from '../../context/PageHeaderContext';
import './B2BSchedulesPage.scss';

const B2BSchedulesPage = () => {
  usePageHeader({
    title: '일정 관리',
    subtitle: '예정된 조사 일정을 확인하고 관리하세요',
    showBack: false,
  });

  return (
    <B2BLayout hideCollapseButton={false}>
      <div className="b2b-schedules-page">
        <div className="b2b-page-content">
          <div className="b2b-placeholder">
            <p>준비 중입니다...</p>
          </div>
        </div>
      </div>
    </B2BLayout>
  );
};

export default B2BSchedulesPage;

